(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.sis-mobile-help a, .sis-header-help a');
  if (!link) return;
  link.closest('.sis-mobile-help, .sis-header-help').open = false;
  const menu = link.closest('.mobile-menu');
  if (menu) {
    menu.open = false;
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('is-locked');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if(!customElements.get('product-recommendations')){
    customElements.define('product-recommendations',class extends HTMLElement{
      connectedCallback(){
        const observer=new IntersectionObserver((entries)=>{if(!entries[0].isIntersecting)return;observer.disconnect();fetch(this.dataset.url).then(response=>response.text()).then(text=>{const html=new DOMParser().parseFromString(text,'text/html').querySelector('product-recommendations');if(html&&html.innerHTML.trim())this.innerHTML=html.innerHTML})},{rootMargin:'0px 0px 400px 0px'});
        observer.observe(this)
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
